// Module
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionRoutingModule } from './session-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';

// Component
import { SessionLoginComponent } from './login/login.component';
import { SessionBrowserComponent } from './browser/browser.component';
import { LineLoginComponent } from './line-login/line-login.component';
import { LineCancelComponent } from './line-cancel/line-cancel.component';

@NgModule({
  imports: [CommonModule, CoreModule, SharedModule, SessionRoutingModule],
  declarations: [SessionLoginComponent, SessionBrowserComponent, LineLoginComponent, LineCancelComponent]
})
export class SessionModule {}
